const FETCH_CHARACTERS = 'characters/FETCH_CHARACTERS';

export default {
  FETCH_CHARACTERS,
};



// WEBPACK FOOTER //
// ./src/app/redux/front/characters/types.js